import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { ShowClientError } from "source/app/presentation/Shared/ErrorBoundary";
import MotwLogicServer from "source/app/services/External/LogicServer/MotwLogicServer";
import { SetState } from "source/app/services/UI/State/SetState";
import { ISyncNotificationState } from "../ISyncNotificationState";
import { HasActiveClientSession } from "source/app/services/Authentication/ClientSession";

export function InitializePolling() {
    let stopped = false;
    let pending = false;
    const intervalId = window.setInterval(() => {
        if (
            stopped ||
            pending ||
            document.visibilityState === "hidden" ||
            !HasActiveClientSession()
        )
            return;
        pending = true;

        MotwLogicServer.GetUserDetails((error) => {
            if (stopped) return;
            HandleUnauthorizedRequest(error);
            if (!HasActiveClientSession()) return;

            SetState<ISyncNotificationState>(
                ESharedFunction.SyncNotification_state,
                {
                    syncNotificationElement: (
                        <span style={{ color: `coral` }}>you are offline</span>
                    ),
                }
            );
        }).then((userDto) => {
            if (stopped || !HasActiveClientSession() || !userDto) return;
            SetState<ISyncNotificationState>(
                ESharedFunction.SyncNotification_state,
                { userDto }
            );
        }).finally(() => { pending = false; });
    }, pollingTimeMs);

    return () => { stopped = true; window.clearInterval(intervalId); };
}

function HandleUnauthorizedRequest(error: any) {
    if (error?.response?.status === 401) {
        ShowClientError(error);
        return;
    }
}

export const pollingTimeMs = 10000;
